import React from "react"

import Edges from "../../Edges"
import ProductFeatures from "../../shopifyProduct/productFeatures/ProductFeatures"
import ProductOverview from "../../shopifyProduct/productOverview/ProductOverview"
import ExpertBlock from "../../shopifyProduct/expertBlock/ExpertBlock"
import DetailedSpecifications from "../../shopifyProduct/detailedSpecifications/DetailedSpecifications"
import CompatibleApps from "../../shopifyProduct/compatibleApps/CompatibleApps"
import SocialBlock from "../../shopifyProduct/socialBlock/SocialBlock"
import RecommendedProducts from "../../shopifyProduct/recommendedProducts/RecommendedProducts"
import BrandCarousel from "../../shopifyProduct/brandCarousel/BrandCarousel"
import Wysiwyg from "../../Wysiwyg"

import useThemeOptions from "../../../hooks/useThemeOptions"
import useAllCollections from "../../../hooks/useAllCollections"
import useAllBuyersGuides from "../../../hooks/useAllBuyersGuides"
import useCollectionBuyersGuide from "./useCollectionBuyersGuide"

const AcfProductContent = props => {
  const {
    product,
    featuresHeading,
    featuresSection,
    productOverviewHeading,
    productOverviewGroup,
    detailedSpecificationsHeading,
    detailedSpecificationsGroup,
    compatibleAppsHeading,
    compatibleAppsDescription,
    compatibleAppsApplications,
    expertGuidance,
    socialBlock,
    recommendationsDisabled,
    customRecommendations,
    overrideActive,
    buyersGuideOverride,
  } = props

  const {
    Options: {
      globalExpertGuidance,
      globalCompatibleApps,
      globalProductOverview,
      globalFeatures,
      globalSocialBlock,
      globalDetailedSpecifications,
      globalRecommendedProducts,
    },
  } = useThemeOptions()

  const allBrands = useAllCollections()
  const allBuyersGuides = useAllBuyersGuides()

  const brand =
    product?.vendor &&
    allBrands?.find?.(brand => brand.title === product?.vendor)
  const mainBuyersGuide =
    product?.productType &&
    allBuyersGuides?.find?.(guide => guide.title === product?.productType)

  const collectionBuyersGuide = useCollectionBuyersGuide(product)

  return (
    <>
      {featuresSection && (
        <ProductFeatures
          section={featuresSection}
          featuresHeading={
            featuresHeading ? featuresHeading : globalFeatures?.featuresHeading
          }
        />
      )}

      {productOverviewGroup && (
        <ProductOverview
          productOverviewHeading={
            productOverviewHeading
              ? productOverviewHeading
              : globalProductOverview?.productOverviewHeading
          }
          groups={productOverviewGroup}
        />
      )}

      {compatibleAppsApplications && (
        <CompatibleApps
          description={
            compatibleAppsDescription !== true
              ? compatibleAppsDescription
              : globalCompatibleApps?.compatibleAppsDescription
          }
          heading={
            compatibleAppsHeading
              ? compatibleAppsHeading
              : globalCompatibleApps?.compatibleAppsHeading
          }
          apps={compatibleAppsApplications}
        />
      )}
      {detailedSpecificationsGroup && (
        <DetailedSpecifications
          groups={detailedSpecificationsGroup}
          heading={
            detailedSpecificationsHeading
              ? detailedSpecificationsHeading
              : globalDetailedSpecifications?.detailedSpecificationsHeading
          }
          backgroundColor=""
        />
      )}

      {brand && <BrandCarousel {...brand.BrandCarousel} />}

      {mainBuyersGuide && (
        <Edges size="md">
          <div id="buyers-guide" className="mb-[50px] mt-[50px]">
            <Wysiwyg content={mainBuyersGuide?.content} />
          </div>
        </Edges>
      )}

      {(collectionBuyersGuide || buyersGuideOverride?.buyersGuide?.text) && (
        <Edges size="md">
          <div id="buyers-guide" className="mb-[50px]">
            <Wysiwyg
              content={
                overrideActive && buyersGuideOverride
                  ? buyersGuideOverride?.buyersGuide?.text
                  : collectionBuyersGuide
              }
            />
          </div>
        </Edges>
      )}

      {!recommendationsDisabled && (
        <RecommendedProducts
          product={product}
          customRecommendations={customRecommendations?.products}
          heading={
            customRecommendations?.heading
              ? customRecommendations?.heading
              : globalRecommendedProducts?.heading
          }
        />
      )}
      {socialBlock && (
        <SocialBlock
          heading={
            socialBlock?.heading
              ? socialBlock?.heading
              : globalSocialBlock?.heading
          }
          description={
            socialBlock?.description
              ? socialBlock?.description
              : globalSocialBlock?.description
          }
          socialIcons={
            socialBlock?.socialIcons
              ? socialBlock?.socialIcons
              : globalSocialBlock?.socialIcons
          }
          slider={socialBlock?.slider}
        />
      )}
      <ExpertBlock
        heading={
          expertGuidance?.heading
            ? expertGuidance?.heading
            : globalExpertGuidance?.heading
        }
        headingImage={
          expertGuidance?.headingImage
            ? expertGuidance?.headingImage
            : globalExpertGuidance?.headingImage
        }
        description={
          expertGuidance?.description
            ? expertGuidance?.description
            : globalExpertGuidance?.description
        }
        buttonGroup={
          expertGuidance?.buttonGroup
            ? expertGuidance?.buttonGroup
            : globalExpertGuidance?.buttonGroup
        }
      />
    </>
  )
}

export default AcfProductContent
